// Import model
import { LeadTypeCondition } from '../models/LeadTypeCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { LeadTypeIndexedFields } from '../models/LeadTypeIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { LeadTypeIndexedFieldsSerializer } from './LeadTypeIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for LeadTypeCondition - handles JSON serialization and deserialization with type validation
 */
export class LeadTypeConditionSerializer {
  /**
   * Deserializes a JSON string into a LeadTypeCondition instance
   */
  static deserialize(json: string): LeadTypeCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a LeadTypeCondition instance
   */
  static fromObject(obj: any): LeadTypeCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to LeadTypeCondition');
    }


    const instance: LeadTypeCondition = {
      fieldName: obj['fieldName'] as LeadTypeIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of LeadTypeCondition instances
   */
  static deserializeArray(json: string): LeadTypeCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a LeadTypeCondition instance to a JSON string
   */
  static serialize(instance: LeadTypeCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a LeadTypeCondition instance to a plain object
   */
  static toObject(instance: LeadTypeCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of LeadTypeCondition instances to a JSON string
   */
  static serializeArray(instances: LeadTypeCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
